<template>
  <!-- eslint-disable-next-line vue/no-v-html -- the policy links escape their names and URLs -->
  <p v-show="policies.length" v-html="policiesText" class="input-policy"></p>
</template>

<script>
import escapeHtml from "helpers/escape_html"
import toSentence from "helpers/to_sentence"

export default {
  props: {
    sitePolicies: Array
  },

  data() {
    return {
      policies: this.sitePolicies
    }
  },

  computed: {
    policiesText() {
      let policyLinks = this.policies.map(policy => {
        return `<a href="${escapeHtml(policy.url)}" target="_blank">${escapeHtml(policy.name)}</a>`
      })

      return this.t(".policies_text", { policy_links: toSentence(policyLinks) })
    }
  }
}
</script>
